export default __webpack_public_path__ + "static/media/menu-help-center.e4b86b2a.svg";